<script lang="ts">
    import TemplateSettingsGeneral from './TemplateSettingsGeneral.svelte';
    import { locale, locales } from 'svelte-i18n';
    import { _ } from 'svelte-i18n';
    import { langs } from '../../../locale/langs.js';
    import { clientSettings } from '../../../stores/api';
    import Select from '../../shared/Select.svelte';
    import { onMount } from 'svelte';

    export let updateClient: () => void;

    let items: { id: string; label: string }[] = [];

    locale.subscribe(value => {
        console.debug('saving setting locale:', value);
        if (typeof value === 'string') {
            value = value.toLowerCase();
            $clientSettings.locale = value;
            updateClient();
        }
    });

    onMount(() => {
        items = $locales.map(locale => {
            return {
                id: locale,
                label: langs.find(l => l.id === locale)?.label || locale,
            };
        });
    });
</script>

<TemplateSettingsGeneral>
    <div slot="label">{$_('Language')}</div>
    <div slot="content">
        <Select
            selected={$locale}
            {items}
            onChange={s => {
                locale.set(s);
                updateClient();
            }}
        />
    </div>
</TemplateSettingsGeneral>

<style>
    .settings-select {
        box-sizing: border-box;
        width: 100%;
        padding: 3px 6px;
        margin: 0 3px;
        background-color: #ffffff;
        border: 0;
        border-radius: 4px;
    }
</style>
